import React, { useState, useEffect, useContext, createContext } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'antd';

import { DataContext } from '../../init/getData';
import toast from 'react-hot-toast';

export const selectedMissionContext = createContext();

function VoidModal(props) {

  const { api, showModal, toggleModal, title, table, refreshTable, idRow, refreshData, data } = props;
  const [loadingEffect, setLoadingEffect] = useState(false);

  const { serverApi, localApi, devData, sessionId, userData } = useContext(DataContext);


  const trigger = async () => {
    setLoadingEffect(true);

    try {

      data.userId = userData.id;
      data.sessionId = sessionId;
      let res = await api.post(`${table}/trash`, JSON.stringify(data));
      if (res.data.status) {
        toast.success(res.data.message);
        toggleModal();
        if (refreshTable) { refreshTable() };
        if (refreshData) { refreshData() };
      } else {
        toast.error(res.data.message);
      }
      setLoadingEffect(false);
    } catch (error) {
      toast.error("Failed Contact Support");
      console.log(error)
    } finally {
      setLoadingEffect(false);
    }
  }


  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static'>
      <Modal.Header style={{ background: "#e6434f" }}>
        <Modal.Title className="arabicText" style={{ color: "white" }}>Void {title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">
        Voiding this PI will void all associated payments. Do you wish to proceed?
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" onClick={toggleModal} style={{ backgroundColor: '#6d747d' }} >cancel</Button>
          <Button type="primary" size="large" loading={loadingEffect} onClick={trigger}
            style={{ marginLeft: '10px' }} danger>Yes</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default VoidModal;
